import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * Admin Route wrapper component
 * Only allows access to users with admin role
 */
const AdminRoute = ({ children }) => {
  // Get user data from localStorage
  // The login component stores user data as 'current_user'
  const userStr = localStorage.getItem("current_user");
  const user = userStr ? JSON.parse(userStr) : null;
  
  const isAdmin = user && user.isAdmin === true;

  if (!isAdmin) {
    // Redirect to login if not admin
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;
